import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "grey--text caption"
}
const _hoisted_2 = {
  key: 1,
  class: "grey--text caption"
}
const _hoisted_3 = {
  key: 1,
  class: "grey--text caption"
}
const _hoisted_4 = {
  key: 1,
  class: "grey--text caption"
}
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_ossAccountingPeriodSelector = _resolveComponent("ossAccountingPeriodSelector")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ossDatePicker = _resolveComponent("ossDatePicker")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_pie_chart = _resolveComponent("pie-chart")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_calendar = _resolveComponent("v-calendar")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Statistiques de suivi des utilisateurs ou des dossiers", -1)),
      _createVNode(_component_v_divider, { class: "my-3" }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.mode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mode) = $event)),
                        items: _ctx.modes,
                        label: "Mode",
                        "item-value": "value",
                        "hide-details": "",
                        "item-title": (item) => item.text
                      }, null, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  (_ctx.mode === 'user')
                    ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            modelValue: _ctx.selectedUsers,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                            items: _ctx.users,
                            label: "Utilisateurs",
                            "item-value": "value",
                            multiple: "",
                            dense: "",
                            chips: "",
                            outlined: "",
                            "hide-details": "",
                            "item-title": (item) => item.key
                          }, {
                            selection: _withCtx(({ item, index }) => [
                              (index < 3)
                                ? (_openBlock(), _createBlock(_component_v_chip, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(item.key), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (index == 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(+" + _toDisplayString(_ctx.selectedUsers.length - 3) + " others)", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.mode === 'user')
                    ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            modelValue: _ctx.filterCompany,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterCompany) = $event)),
                            items: _ctx.allAvailableCompanies,
                            label: "Société",
                            "item-value": "value",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            "item-title": (item) => item.key
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.mode === 'company')
                    ? (_openBlock(), _createBlock(_component_v_col, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            modelValue: _ctx.selectedCompanies,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                            items: _ctx.allAvailableCompanies,
                            label: "Société",
                            "item-value": "value",
                            multiple: "",
                            chips: "",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            "item-title": (item) => item.key
                          }, {
                            selection: _withCtx(({ item, index }) => [
                              (index < 3)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    dense: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(item.key), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (index == 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(+" + _toDisplayString(_ctx.selectedCompanies.length - 3) + " others)", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.mode === 'company')
                    ? (_openBlock(), _createBlock(_component_v_col, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            modelValue: _ctx.filterUser,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterUser) = $event)),
                            items: _ctx.users,
                            label: "Utilisateur",
                            "item-value": "value",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            "item-title": (item) => item.key
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.companyId && _ctx.mode === 'company')
                    ? (_openBlock(), _createBlock(_component_v_col, { key: 4 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ossAccountingPeriodSelector, {
                            modelValue: _ctx.accountingPeriod,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.accountingPeriod) = $event)),
                            global: false,
                            companyId: _ctx.companyId,
                            "hide-details": "",
                            dense: ""
                          }, null, 8, ["modelValue", "companyId"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedAction,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedAction) = $event)),
                        items: _ctx.actionUserActivity,
                        label: "Action utilisateur",
                        "item-value": "value",
                        multiple: "",
                        chips: "",
                        "hide-details": "",
                        "item-title": (item) => item.key
                      }, {
                        selection: _withCtx(({ item, index }) => [
                          (index < 2)
                            ? (_openBlock(), _createBlock(_component_v_chip, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(item.key), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (index == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(+" + _toDisplayString(_ctx.selectedAction.length - 2) + " others)", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedTypeAction,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedTypeAction) = $event)),
                        items: _ctx.typeActionUserActivity,
                        label: "Type de document",
                        "item-value": "value",
                        multiple: "",
                        chips: "",
                        "hide-details": "",
                        "item-title": (item) => item.key
                      }, {
                        selection: _withCtx(({ item, index }) => [
                          (index < 2)
                            ? (_openBlock(), _createBlock(_component_v_chip, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(item.key), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (index == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(+" + _toDisplayString(_ctx.selectedTypeAction.length - 2) + " others)", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_icon, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearFilter())),
                        icon: "$delete"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedUnitOfTime,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedUnitOfTime) = $event)),
                        items: _ctx.unitOfTime,
                        label: "Affichage",
                        "item-value": "value",
                        "hide-details": "",
                        "item-title": (item) => item.key
                      }, null, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ossDatePicker, {
                        modelValue: _ctx.startDate,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.startDate) = $event)),
                        label: "Début",
                        "hide-details": "",
                        textFieldReadOnly: false
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ossDatePicker, {
                        modelValue: _ctx.endDate,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.endDate) = $event)),
                        label: "Fin",
                        "hide-details": "",
                        textFieldReadOnly: false
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "default_card dashboard_card",
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode(" Nombre d'actions ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_container, null, {
                            default: _withCtx(() => [
                              (_ctx.mode === 'user')
                                ? (_openBlock(), _createBlock(_component_bar_chart, {
                                    data: _ctx.dataBarChart(_ctx.usersDocsValues, 'nbr'),
                                    options: _ctx.options,
                                    height: 200,
                                    key: _ctx.keyIndex
                                  }, null, 8, ["data", "options"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_container, null, {
                            default: _withCtx(() => [
                              (_ctx.mode === 'company')
                                ? (_openBlock(), _createBlock(_component_bar_chart, {
                                    data: _ctx.dataBarChart(_ctx.companiesDocsValues, 'nbr'),
                                    options: _ctx.options,
                                    height: 200,
                                    key: _ctx.keyIndex
                                  }, null, 8, ["data", "options"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.mode === 'user' && _ctx.userId && _ctx.userCompaniesActivities)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "mt-4 d-flex align-center justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_pie_chart, {
                    data: _ctx.userCompaniesActivities,
                    options: {
                        plugins: { legend: { display: true, position: 'bottom' } },
                        maintainAspectRatio: false,
                        ticks: { min: 0 },
                    },
                    height: _ctx.$vuetify.display.mobile ? 200 : 300
                  }, null, 8, ["data", "height"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.mode === 'company' && _ctx.companyId && _ctx.companyUsersActivities)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "mt-4 d-flex align-center justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_pie_chart, {
                    data: _ctx.companyUsersActivities,
                    options: {
                        plugins: { legend: { display: true, position: 'bottom' } },
                        maintainAspectRatio: false,
                        ticks: { min: 0 },
                    },
                    height: _ctx.$vuetify.display.mobile ? 200 : 300
                  }, null, 8, ["data", "height"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_ctx.totalTime)
            ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.formatTotalTime), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.activities.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_sheet, {
              tile: "",
              height: "54",
              class: "d-flex justify center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar, { flat: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select_filled, {
                      modelValue: _ctx.type,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.type) = $event)),
                      items: _ctx.types,
                      "hide-details": "",
                      label: "type",
                      class: "ml-2"
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_select_filled, {
                      modelValue: _ctx.mergeDelta,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mergeDelta) = $event)),
                      items: _ctx.mergeDeltas,
                      outlined: "",
                      "hide-details": "",
                      label: "Ecart de fusion",
                      class: "ml-2"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_sheet, { height: "600" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_calendar, {
                  ref: "calendar",
                  modelValue: _ctx.focus,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.focus) = $event)),
                  color: 'secondary',
                  events: _ctx.activities,
                  "view-mode": _ctx.type
                }, null, 8, ["modelValue", "events", "view-mode"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}